module.exports = __webpack_public_path__ + "static/media/home.f172de8f.svg";